"use strict";

exports.__esModule = true;
exports.CommentTableThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _Measures = require("../../Measures");
var _timeDefinitions = require("../../timeDefinitions");
var _class, _CommentTableThumbnail;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var fakeSentences = ["Lorem ipsum dolor sit amet, consectetur adipiscing elit.", "sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.", "Duis aute irure dolor in reprehenderit in voluptate velit", "esse cillum dolore eu fugiat nulla pariatur.", "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt", "mollit anim id est laborum"];

/**
 * Thumbnail for CommentTableWidget.
 */
var CommentTableThumbnail = exports.CommentTableThumbnail = (0, _Core.withTranslator)(_class = (_CommentTableThumbnail = /*#__PURE__*/function (_Component) {
  function CommentTableThumbnail() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.now = Date.now();
    _this.renderRow = function (_ref) {
      var index = _ref.index,
        top = _ref.top,
        left = _ref.left,
        height = _ref.height;
      var columnWidths = _this.getColumnWidths();
      var columnContents = _this.getColumnContents(index);
      var body = [];
      var x = left;
      for (var i = 0; i < columnWidths.length; i++) {
        var width = columnWidths[i];
        body.push(/*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
          key: index + ":" + i,
          x: x,
          y: top,
          width: width,
          height: height,
          value: columnContents[i]
        }));
        x += width;
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: index
      }, body);
    };
    return _this;
  }
  _inheritsLoose(CommentTableThumbnail, _Component);
  var _proto = CommentTableThumbnail.prototype;
  _proto.getColumnWidths = function getColumnWidths() {
    var width = this.props.width;
    var device = width / 6;
    var createdAt = width / 6;
    var createdBy = width / 6;
    var body = width - (device + createdAt + createdBy);
    return [device, createdAt, createdBy, body];
  };
  _proto.getColumnLabels = function getColumnLabels() {
    var translator = this.props.translator;
    var translate = translator.translate;
    return [translate("CommentTableThumbnail.device", "Device"), translate("CommentTableThumbnail.createdAt", "Created At"), translate("CommentTable.createdBy", "Created By"), translate("CommentTable.comment", "Comment")];
  };
  _proto.getColumnContents = function getColumnContents(index) {
    var device = "Device " + (index + 1);
    var createdAt = new Date(this.now - index * _timeDefinitions.DAY_IN_MILLIS).toLocaleString();
    var createdBy = "User " + (index + 1);
    var comment = fakeSentences[index % fakeSentences.length];
    return [device, createdAt, createdBy, comment];
  };
  _proto.render = function render() {
    var _this$props = this.props,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height;
    var itemHeight = 80;
    var availableHeight = height - itemHeight;
    var totalVisible = Math.ceil(availableHeight / itemHeight);
    var visible = [];
    var top = 0;
    for (var index = 0; index < totalVisible; index++) {
      visible.push(this.renderRow({
        index: index,
        top: top,
        left: 0,
        width: width,
        height: itemHeight
      }));
      top += itemHeight;
    }
    return /*#__PURE__*/_react["default"].createElement("svg", {
      x: x,
      y: y,
      width: width,
      height: height
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      x: 0,
      y: 0,
      width: width,
      height: height,
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("svg", {
      width: width,
      height: itemHeight
    }, this.renderHeaders()), /*#__PURE__*/_react["default"].createElement("svg", {
      x: 0,
      y: itemHeight,
      width: width,
      height: availableHeight
    }, visible));
  };
  _proto.renderHeaders = function renderHeaders() {
    var height = 80;
    var columnWidths = this.getColumnWidths();
    var columnLabels = this.getColumnLabels();
    var headers = [];
    var x = 0;
    for (var index = 0; index < columnWidths.length; index++) {
      var width = columnWidths[index];
      headers.push(/*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
        key: String(index),
        x: x,
        y: 0,
        width: width,
        height: height,
        fontSize: 24,
        value: columnLabels[index]
      }));
      x += width;
    }
    return headers;
  };
  return CommentTableThumbnail;
}(_react.Component), _CommentTableThumbnail.defaultProps = {
  width: 1024,
  height: 768,
  translator: undefined
}, _CommentTableThumbnail)) || _class;